import React from 'react';

class AirconICon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_254_1374)">
          <path
            d="M10.57 17.8359H69.43C71.952 17.8359 74 19.8839 74 22.4059V37.0359H6V22.4059C6 19.8839 8.048 17.8359 10.57 17.8359Z"
            fill="#F7F4F1"
          />
          <path
            d="M6 36.9639H74V43.6579C74 46.1459 71.98 48.1639 69.494 48.1639H10.506C8.018 48.1639 6 46.1439 6 43.6579V36.9639Z"
            fill="#E0DDDA"
          />
          <path d="M66 43.3638H14V48.1638H66V43.3638Z" fill="white" />
          <path
            d="M69.4302 17.0359H10.5702C7.6082 17.0359 5.2002 19.4459 5.2002 22.4059V43.6559C5.2002 46.5819 7.5802 48.9619 10.5062 48.9619H69.4942C72.4202 48.9619 74.8002 46.5819 74.8002 43.6559V22.4059C74.8002 19.4439 72.3902 17.0359 69.4302 17.0359ZM14.8002 47.3639V44.1639H65.2002V47.3639H14.8002ZM69.4942 47.3639H66.8002V43.3639C66.8002 42.9219 66.4422 42.5639 66.0002 42.5639H14.0002C13.5582 42.5639 13.2002 42.9219 13.2002 43.3639V47.3639H10.5062C8.4622 47.3639 6.8002 45.7019 6.8002 43.6579V37.8359H73.2002V43.6579C73.2002 45.7019 71.5382 47.3639 69.4942 47.3639ZM6.8002 36.1639V22.4059C6.8002 20.3259 8.4922 18.6359 10.5702 18.6359H69.4302C71.5102 18.6359 73.2002 20.3279 73.2002 22.4059V36.1639H6.8002Z"
            fill="#83837F"
          />
          <path
            d="M19.766 29.8359H11.766C10.8824 29.8359 10.166 30.5523 10.166 31.4359C10.166 32.3196 10.8824 33.0359 11.766 33.0359H19.766C20.6497 33.0359 21.366 32.3196 21.366 31.4359C21.366 30.5523 20.6497 29.8359 19.766 29.8359Z"
            fill="url(#paint0_linear_254_1374)"
          />
          <path
            d="M24.6006 66.9638C24.1586 66.9638 23.8006 66.6058 23.8006 66.1638C23.8006 65.6938 23.6506 65.5058 23.3766 65.1638C23.0486 64.7558 22.6006 64.1938 22.6006 63.1638C22.6006 62.1338 23.0486 61.5738 23.3766 61.1638C23.6506 60.8218 23.8006 60.6338 23.8006 60.1638C23.8006 59.6938 23.6506 59.5058 23.3766 59.1638C23.0486 58.7558 22.6006 58.1938 22.6006 57.1638C22.6006 56.1338 23.0486 55.5738 23.3766 55.1638C23.6506 54.8218 23.8006 54.6338 23.8006 54.1638C23.8006 53.7218 24.1586 53.3638 24.6006 53.3638C25.0426 53.3638 25.4006 53.7218 25.4006 54.1638C25.4006 55.1938 24.9526 55.7538 24.6246 56.1638C24.3506 56.5058 24.2006 56.6938 24.2006 57.1638C24.2006 57.6338 24.3506 57.8218 24.6246 58.1638C24.9526 58.5718 25.4006 59.1338 25.4006 60.1638C25.4006 61.1938 24.9526 61.7538 24.6246 62.1638C24.3506 62.5058 24.2006 62.6938 24.2006 63.1638C24.2006 63.6338 24.3506 63.8218 24.6246 64.1638C24.9526 64.5738 25.4006 65.1338 25.4006 66.1638C25.4006 66.6058 25.0426 66.9638 24.6006 66.9638Z"
            fill="url(#paint1_linear_254_1374)"
          />
          <path
            d="M30.6006 66.9638C30.1586 66.9638 29.8006 66.6058 29.8006 66.1638C29.8006 65.6938 29.6506 65.5058 29.3766 65.1638C29.0486 64.7558 28.6006 64.1938 28.6006 63.1638C28.6006 62.1338 29.0486 61.5738 29.3766 61.1638C29.6506 60.8218 29.8006 60.6338 29.8006 60.1638C29.8006 59.6938 29.6506 59.5058 29.3766 59.1638C29.0486 58.7558 28.6006 58.1938 28.6006 57.1638C28.6006 56.1338 29.0486 55.5738 29.3766 55.1638C29.6506 54.8218 29.8006 54.6338 29.8006 54.1638C29.8006 53.7218 30.1586 53.3638 30.6006 53.3638C31.0426 53.3638 31.4006 53.7218 31.4006 54.1638C31.4006 55.1938 30.9526 55.7538 30.6246 56.1638C30.3506 56.5058 30.2006 56.6938 30.2006 57.1638C30.2006 57.6338 30.3506 57.8218 30.6246 58.1638C30.9526 58.5718 31.4006 59.1338 31.4006 60.1638C31.4006 61.1938 30.9526 61.7538 30.6246 62.1638C30.3506 62.5058 30.2006 62.6938 30.2006 63.1638C30.2006 63.6338 30.3506 63.8218 30.6246 64.1638C30.9526 64.5738 31.4006 65.1338 31.4006 66.1638C31.4006 66.6058 31.0426 66.9638 30.6006 66.9638Z"
            fill="url(#paint2_linear_254_1374)"
          />
          <path
            d="M36.6006 66.9638C36.1586 66.9638 35.8006 66.6058 35.8006 66.1638C35.8006 65.6938 35.6506 65.5058 35.3766 65.1638C35.0486 64.7558 34.6006 64.1938 34.6006 63.1638C34.6006 62.1338 35.0486 61.5738 35.3766 61.1638C35.6506 60.8218 35.8006 60.6338 35.8006 60.1638C35.8006 59.6938 35.6506 59.5058 35.3766 59.1638C35.0486 58.7558 34.6006 58.1938 34.6006 57.1638C34.6006 56.1338 35.0486 55.5738 35.3766 55.1638C35.6506 54.8218 35.8006 54.6338 35.8006 54.1638C35.8006 53.7218 36.1586 53.3638 36.6006 53.3638C37.0426 53.3638 37.4006 53.7218 37.4006 54.1638C37.4006 55.1938 36.9526 55.7538 36.6246 56.1638C36.3506 56.5058 36.2006 56.6938 36.2006 57.1638C36.2006 57.6338 36.3506 57.8218 36.6246 58.1638C36.9526 58.5718 37.4006 59.1338 37.4006 60.1638C37.4006 61.1938 36.9526 61.7538 36.6246 62.1638C36.3506 62.5058 36.2006 62.6938 36.2006 63.1638C36.2006 63.6338 36.3506 63.8218 36.6246 64.1638C36.9526 64.5738 37.4006 65.1338 37.4006 66.1638C37.4006 66.6058 37.0426 66.9638 36.6006 66.9638Z"
            fill="url(#paint3_linear_254_1374)"
          />
          <path
            d="M56.4005 62.4717L52.4045 60.1637L56.4005 57.8557C56.7825 57.6357 56.9145 57.1457 56.6925 56.7637C56.4725 56.3817 55.9825 56.2497 55.6005 56.4717L51.6045 58.7797V54.1657C51.6045 53.7237 51.2465 53.3657 50.8045 53.3657C50.3625 53.3657 50.0045 53.7237 50.0045 54.1657V58.7797L46.0085 56.4717C45.6265 56.2497 45.1365 56.3817 44.9165 56.7637C44.6965 57.1457 44.8265 57.6357 45.2085 57.8557L49.2045 60.1637L45.2085 62.4717C44.8265 62.6917 44.6945 63.1817 44.9165 63.5637C45.0645 63.8197 45.3325 63.9637 45.6105 63.9637C45.7465 63.9637 45.8845 63.9297 46.0105 63.8557L50.0065 61.5477V66.1617C50.0065 66.6037 50.3645 66.9617 50.8065 66.9617C51.2485 66.9617 51.6065 66.6037 51.6065 66.1617V61.5477L55.6025 63.8557C55.7285 63.9277 55.8665 63.9637 56.0025 63.9637C56.2785 63.9637 56.5485 63.8197 56.6965 63.5637C56.9165 63.1817 56.7865 62.6917 56.4045 62.4717H56.4005Z"
            fill="url(#paint4_linear_254_1374)"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_254_1374"
            x="3.8002"
            y="15.6359"
            width="75.5996"
            height="55.928"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_254_1374"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_254_1374"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_254_1374"
            x1="11.7413"
            y1="30.1222"
            x2="12.7698"
            y2="34.2513"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_254_1374"
            x1="22.9944"
            y1="54.5802"
            x2="27.1633"
            y2="55.5647"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_254_1374"
            x1="28.9944"
            y1="54.5802"
            x2="33.1633"
            y2="55.5647"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_254_1374"
            x1="34.9944"
            y1="54.5802"
            x2="39.1633"
            y2="55.5647"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_254_1374"
            x1="46.4957"
            y1="54.5818"
            x2="55.8111"
            y2="64.0087"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
}

export default AirconICon;
